// attendance.service.ts
import { Injectable } from '@angular/core';
import { CMSDynamicService } from './cms-service';


@Injectable({
  providedIn: 'root',
})
export class AttendanceService {
  constructor(private cmsService: CMSDynamicService) {}

  /** Ders başlatma isteği gönderir (öğretmen tarafı) */
  async startCourse(item: any): Promise<any> {


    return this.cmsService.postItem('Yoklama', 'AddCourseStart', '', item, false);
  }

  /** Başlatılmış ders bilgisini günceller */
  async updateCourse(body: any): Promise<any> {
    return this.cmsService.post('Yoklama', 'UpdateCourseStart', '', body, false);
  }

  /** Öğrenci yoklama gönderme (QR token içeriğiyle) */
  async sendAttendance(body: any): Promise<any> {
    return this.cmsService.post('Yoklama', 'SendAttendance', '', body, false);
  }

  /** Dersi başlatan öğretmen için yoklama durumlarını getirir */
  async getAttendanceList(courseStartId: number, acilanDersNo: number, yoklamaNo: number,baslangicSaati:string, bitisSaati:string): Promise<any> {
    return this.cmsService.getListe('Yoklama', `GetAttendanceByCourseAndYoklama?courseId=${courseStartId}&acilanDersNo=${acilanDersNo}&yoklamaNo=${yoklamaNo}&baslangicSaati=${baslangicSaati}&bitisSaati=${bitisSaati  }`);
  }

  /** Öğrencinin o derse yoklamasının alınıp alınmadığını kontrol eder */
  async getMyAttendanceStatus(courseStartId: number): Promise<any> {
    return this.cmsService.get(0, 0, 'Yoklama', `GetMyAttendance/${courseStartId}`);
  }

  /** UTC zamanı getirir */
  async fetchUtcTime(): Promise<Date | null> {
    const res: any = await this.cmsService.get(0, 0, 'Yoklama', 'utc');
    if (res?.utcDateTime) {
      return new Date(res.utcDateTime);
    }
    return null;
  }
}
